export const DATE_FORMAT = {
  ymdDash: 'yyyy-MM-dd',
  ymdDot: 'yyyy.MM.dd',
  dmyDash: 'dd-MM-yyyy',
  dmyDot: 'dd.MM.yyyy',
  dmyShort: 'dd MMM yyyy',
  dmyLong: 'dd MMMM yyyy',
  myShort: 'LLL yy',
  mydLong: 'LLLL yy',
  dmyAllShort: 'dd MMM yy',
} as const
